<template>
  <b-card>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    cat: {
      type: String,
      required: true
    }
  },
  methods: {}
};
</script>
<style lang="css" scoped></style>
